<template>
  <div>
    <b-dropdown id="other-options" toggle-tag="div" toggle-class="p-0 bg-transparent">
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('global.object.other')"
          :disabled="disabled"
        />
      </template>
  
      <b-dropdown-item @click="handleShowHistoryModal">
        {{ 'Riwayat Status Kontrak' }}
      </b-dropdown-item>
  
      <b-dropdown-item
        v-if="isMGM"
        @click="$bvModal.show('integration-log-modal-value-help')"
      >
        <IntegrationLogHistoryModal
          module="md-customer-contract"
          :identifier="$route.params.contractId"
          :hasCustomFeature="false"
        />
        {{ 'Riwayat Log Integrasi' }}
      </b-dropdown-item>
    </b-dropdown>

    <McEventList
      :value.sync="openHistory"
      :data="groupedHistories"
      :keys="groupedHistoryKeys"
      title="Riwayat Status Kontrak"
    />
  </div>
</template>
<script>
import McButton from '@/components/McButton'
import McEventList from '@/components/McEventList'

import * as CustomerContract from '@/services/rest-api/lib/contract/customer-contract'
import IntegrationLogHistoryModal from '@/router/views/master/fleet/components/IntegrationLogHistoryModal'

import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
    McEventList,
    IntegrationLogHistoryModal,
  },
  mixins: [Helper],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openHistory: false,
      groupedHistories: [],
      groupedHistoryKeys: [],
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isMGM() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId())
      )
    },
  },
  methods: {
    async handleShowHistoryModal() {
      this.openHistory = true
      await this.fetchCustomerContractHistory()
    },
    async fetchCustomerContractHistory() {
      try {
        const res = await CustomerContract.getCustomerContractHistory(this.$route.params.contractId)
  
        let historyData = res.data
        historyData = historyData.map((data) => {
          const date = new Date(data.created_on)
  
          const options = { day: '2-digit', month: 'short', year: 'numeric' }
          const formattedDate = date.toLocaleDateString('id-ID', options)
  
          data.date = formattedDate
          return data
        })
        historyData = Object.groupBy(historyData, ({ date }) => date)
        this.groupedHistoryKeys = Object.keys(historyData)
        this.groupedHistories = Object.keys(historyData).map((date) => ({
          [date]: historyData[date],
        }))
      } catch(e) {
        this.$mcToast.error('Telah terjadi kesalahan')
        this.groupedHistories = []
        this.groupedHistoryKeys = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(#other-options) {
  .dropdown-menu {
    right: 0px;
    left: auto !important;
  }

  .dropdown-toggle {
    border: none;
  }
}
</style>